import React from 'react';
export { Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, usePopover, usePopoverContext } from '@chakra-ui/react';
import { usePopoverContext } from '@chakra-ui/react';
export const PopoverTrigger = (props) => {
    const child = React.Children.only(props.children);
    const { getTriggerProps } = usePopoverContext();
    return React.cloneElement(child, getTriggerProps(child.props, child.ref));
};
